import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import { useDispatch } from 'react-redux';
import useTailwindBrand from 'src/Theme/useTailwindBrand';
import FormInput from 'src/Components/Ui/FormInput';
import FormRadioYesNo from 'src/Components/FormFields/FormRadioYesNo';
import FormSection from 'src/Components/FormFields/FormSection';
import { useProcuration } from 'src/Hooks/useProcuration';
import { useProcurationContext } from 'src/Contexts/ProcurationContext';
import { FormErrorsFifthPart } from 'src/Hooks/InterfaceProcuration';
import LayoutProcuration from 'src/Components/Procuration/LayoutProcuration';

const FifthPartAe = () => {
    const { classes } = useTailwindBrand();
    const dispatch = useDispatch();
    const context = useProcurationContext();
    const { teachr, prevStep, nextStep, pdfDoc, triggerPdfUpdate, generalProcuration, setPage } = context;

    const {
        formDataFifthPart,
        errorsFifthPart,
        pdfFiledFieldsFifth,
        setFormDataFifthPart,
        setErrorsFifthPart,
        handleSelect,
        handleChange,
        setAuthorizeSirenDirectoryAccessField,
        setAuthorizePersonalDataProspectingField,
        setAddDomainNameField
    } = useProcuration({ pdfDoc, teachr, triggerPdfUpdate, setPage });

    const values = {
        setField: setFormDataFifthPart,
        error: errorsFifthPart,
        setError: setErrorsFifthPart
    }

    const validate = (): boolean => {
        const newErrors: FormErrorsFifthPart = {
            authorizeSirenDirectoryAccess: formDataFifthPart.authorizeSirenDirectoryAccess === 0 ? 'Veuillez répondre à cette question' : '',
            authorizePersonalDataProspecting: formDataFifthPart.authorizePersonalDataProspecting === 0 ? 'Veuillez répondre à cette question' : '',
            addDomainName: formDataFifthPart.addDomainName === 0 ? 'Veuillez répondre à cette question' : '',
            domainNameValue: formDataFifthPart.addDomainName === 1 && formDataFifthPart.domainNameValue.trim() === '' ? 'Veuillez renseigner un nom de domaine' : ''
        };
        setErrorsFifthPart(newErrors);
        return !Object.values(newErrors).some(error => error !== '');
    };

    const handleNext = () => {
        if (validate()) {
            const payload = {
                step: 7,
                secondProc: generalProcuration?.secondProc || {},
                thirdProc: generalProcuration?.thirdProc || {},
                fourthProc: generalProcuration?.fourthProc || {},
                fifthProc: generalProcuration?.fifthProc || {},
                sixthProc: generalProcuration?.sixthProc || {},
                legalRepProc: generalProcuration?.legalRepProc || [],
                seventhProc: formDataFifthPart,
                eightProc: generalProcuration?.eightProc || {}
            };

            dispatch({ type: 'SET_AE_INFO', payload });
            nextStep(7);
        }
    };

    return (
        <LayoutProcuration
            title="Informations complémentaires"
            icon={<PersonIcon className={`w-6 h-6 ${classes.primaryText}`} />}
            nextStep={handleNext}
            prevStep={prevStep}
            currentStep={4}
            totalSteps={4}
        >
            <FormSection title="Autorisations et consentements">
                <div className="space-y-6">
                    <FormRadioYesNo
                        label="Souhaitez-vous ajouter un nom de domaine ?"
                        value={formDataFifthPart.addDomainName}
                        onChange={(value) => handleSelect(value, 'addDomainName', setAddDomainNameField, values, 4)}
                        error={errorsFifthPart.addDomainName}
                        required={true}
                        name="addDomainName"
                    />

                    {formDataFifthPart.addDomainName === 1 && (
                        <FormInput
                            label="Nom de domaine"
                            type="text"
                            placeholder="Ex: mon-domaine.fr"
                            value={formDataFifthPart.domainNameValue}
                            error={errorsFifthPart.domainNameValue}
                            onChange={(e) => handleChange({ field: 'domainNameValue', pdfField: pdfFiledFieldsFifth.addDomainNameField }, e, values, 4)}
                            name="domainNameValue"
                            required={true}
                        />
                    )}
                    <FormRadioYesNo
                        label="Autorisez-vous que vos informations enregistrées dans le répertoire SIREN soient consultables ou utilisables par des tiers ?"
                        value={formDataFifthPart.authorizeSirenDirectoryAccess}
                        onChange={(value) => handleSelect(value, 'authorizeSirenDirectoryAccess', setAuthorizeSirenDirectoryAccessField, values, 4)}
                        error={errorsFifthPart.authorizeSirenDirectoryAccess}
                        required={true}
                        name="authorizeSirenDirectoryAccess"
                    />

                    <FormRadioYesNo
                        label="Autorisez-vous que vos données personnelles puissent être utilisées à des fins de prospection ?"
                        value={formDataFifthPart.authorizePersonalDataProspecting}
                        onChange={(value) => handleSelect(value, 'authorizePersonalDataProspecting', setAuthorizePersonalDataProspectingField, values, 4)}
                        error={errorsFifthPart.authorizePersonalDataProspecting}
                        required={true}
                        name="authorizePersonalDataProspecting"
                    />
                </div>
            </FormSection>
        </LayoutProcuration>
    );
};

export default FifthPartAe;
